import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      await login(email, password);
      navigate('/campus');
    } catch (err) {
      setError('Invalid email or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        {/* Logo Area */}
        <div style={styles.logoArea}>
          <h1 style={styles.title}>IMPACT INFLUENCE</h1>
          <h2 style={styles.subtitle}>ACADEMY</h2>
          <p style={styles.tagline}>The Science of Influence</p>
        </div>

        {/* Login Form */}
        <div style={styles.formArea}>
          <h3 style={styles.formTitle}>Welcome Back</h3>
          
          {error && <div style={styles.error}>{error}</div>}
          
          <div style={styles.inputGroup}>
            <label style={styles.label}>Email</label>
            <input
              style={styles.input}
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
            />
          </div>

          <div style={styles.inputGroup}>
            <label style={styles.label}>Password</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
            />
          </div>

          <button 
            style={loading ? styles.buttonDisabled : styles.button}
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Enter Campus'}
          </button>
        </div>
      </div>
    </div>
  );
};

// Styles — IIA brand colors
const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#1A2744',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  card: {
    backgroundColor: '#0f1a33',
    borderRadius: '12px',
    padding: '48px',
    width: '100%',
    maxWidth: '420px',
    border: '1px solid #C49A28',
  },
  logoArea: {
    textAlign: 'center',
    marginBottom: '36px',
  },
  title: {
    color: '#C49A28',
    fontSize: '22px',
    fontWeight: '800',
    letterSpacing: '3px',
    margin: '0',
  },
  subtitle: {
    color: '#1A6B8A',
    fontSize: '18px',
    fontWeight: '600',
    letterSpacing: '4px',
    margin: '4px 0 8px 0',
  },
  tagline: {
    color: '#ffffff80',
    fontSize: '13px',
    letterSpacing: '2px',
    margin: '0',
  },
  formArea: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  formTitle: {
    color: '#ffffff',
    fontSize: '18px',
    fontWeight: '600',
    margin: '0 0 8px 0',
    textAlign: 'center',
  },
  error: {
    backgroundColor: '#ff000020',
    border: '1px solid #ff0000',
    color: '#ff6666',
    padding: '10px',
    borderRadius: '6px',
    fontSize: '14px',
    textAlign: 'center',
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
  },
  label: {
    color: '#ffffff80',
    fontSize: '13px',
    letterSpacing: '1px',
  },
  input: {
    backgroundColor: '#1A2744',
    border: '1px solid #ffffff20',
    borderRadius: '6px',
    padding: '12px 16px',
    color: '#ffffff',
    fontSize: '15px',
    outline: 'none',
  },
  button: {
    backgroundColor: '#C49A28',
    color: '#1A2744',
    border: 'none',
    borderRadius: '6px',
    padding: '14px',
    fontSize: '15px',
    fontWeight: '700',
    letterSpacing: '1px',
    cursor: 'pointer',
    marginTop: '8px',
  },
  buttonDisabled: {
    backgroundColor: '#C49A2880',
    color: '#1A2744',
    border: 'none',
    borderRadius: '6px',
    padding: '14px',
    fontSize: '15px',
    fontWeight: '700',
    letterSpacing: '1px',
    cursor: 'not-allowed',
    marginTop: '8px',
  },
};

export default Login;